import { ChevronRight } from '@/src/assets/icons/ChevronRight'
import { MesaMonogram } from '@/src/assets/icons/MesaMonogram'
import { formatCurrency } from '@/src/common/utils/general'
import { DesignSystem } from '@/src/design-system'
import { router } from 'expo-router'
import { TouchableOpacity } from 'react-native'
import { H6, SizableText, styled, View, YStack } from 'tamagui'
import { Routes } from '@/src/common/enums/routes'
import * as Branding from '@/src/experiences/branding'

const StyledChevronRight = styled(
  ChevronRight,
  {
    stroke: '$text',
    size: 20,
  },
  {
    accept: { stroke: 'color' } as const,
  },
)

export function CurrentBalanceCard({
  cardName,
  currentBalanceInCents,
}: {
  cardName: string
  currentBalanceInCents: number
}) {
  const { token: primaryColorToken } = Branding.Hooks.usePrimaryColor()
  const formattedCurrentBalance = formatCurrency(currentBalanceInCents, {
    isFloat: false,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    decimals: 2,
  })
  return (
    <DesignSystem.Card
      style={{
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        backgroundColor: 'transparent',
      }}
    >
      <TouchableOpacity
        onPress={() => {
          router.push(Routes.CardManagement.route)
        }}
        activeOpacity={0.5}
      >
        <View overflow="hidden" rounded="$6">
          <View position="absolute" t={0} l={0} r={0} b={0} z={0}>
            <MesaMonogram mode="light" />
          </View>

          <View flexDirection="row" justify="space-between" items="center" px="$3" py="$2">
            <YStack>
              <H6>{cardName}</H6>
              <SizableText>Current Balance</SizableText>
              <H6 color={primaryColorToken}>{formattedCurrentBalance}</H6>
              <SizableText size="$3" color="$textSubtle">
                Make a payment, view transactions, and more
              </SizableText>
            </YStack>
            <StyledChevronRight />
          </View>
        </View>
      </TouchableOpacity>
    </DesignSystem.Card>
  )
}
